import { render, staticRenderFns } from "./TablesCaisse.vue?vue&type=template&id=52e9c4c0&"
import script from "./TablesCaisse.vue?vue&type=script&lang=js&"
export * from "./TablesCaisse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports